(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lab-consent"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lab-consent')) {
    class LabConsent extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.choice = this.querySelector('[data-choice]');
        this.choice.checked = false;
        this.choice.disabled = false;
        this.choice.addEventListener('change', () => this.save());
        this.closest('form')?.addEventListener('submit', event => {
          if (this.pending || this.failed) {
            event.preventDefault();
            event.stopImmediatePropagation();
            this.querySelector('[data-status]').textContent = this.querySelector(this.pending ? '[data-saving]' : '[data-error]').textContent;
          }
        }, true);
      }
      async save() {
        const yes = this.choice.checked;
        const values = {
          lab_early_start: yes ? 'yes' : 'no',
          lab_consent_text: yes ? this.querySelector('[data-statement]').textContent.trim() : '',
          lab_consent_version: yes ? this.dataset.version : '',
          lab_consent_at: yes ? new Date().toISOString() : '',
          lab_consent_items: yes ? this.dataset.items : '',
          lab_consent_language: yes ? this.dataset.locale : ''
        };
        const peers = [...document.querySelectorAll('lab-consent')];
        peers.forEach(peer => {
          peer.pending = true;
          peer.failed = false;
          peer.querySelector('[data-choice]').disabled = true;
          peer.querySelector('[data-status]').textContent = peer.querySelector('[data-saving]').textContent;
        });
        try {
          const response = await fetch(this.dataset.url, {
            method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ attributes: values })
          });
          if (!response.ok) throw new Error('Consent could not be saved');
          const cart = await response.json();
          if (cart.attributes.lab_early_start !== values.lab_early_start) throw new Error('Consent was not confirmed');
          peers.forEach(peer => {
            peer.querySelector('[data-choice]').checked = yes;
            Object.entries(values).forEach(([key, value]) => { peer.querySelector(`[name="attributes[${key}]"]`).value = value; });
            peer.querySelector('[data-status]').textContent = yes ? peer.querySelector('[data-saved]').textContent : peer.querySelector('.lab-consent__help').textContent;
          });
        } catch (error) {
          peers.forEach(peer => {
            peer.failed = true;
            peer.querySelector('[data-choice]').checked = false;
            peer.querySelectorAll('input[type="hidden"]').forEach(input => { input.value = input.name === 'attributes[lab_early_start]' ? 'no' : ''; });
            peer.querySelector('[data-status]').textContent = peer.querySelector('[data-error]').textContent;
          });
        } finally {
          peers.forEach(peer => {
            peer.pending = false;
            peer.querySelector('[data-choice]').disabled = false;
          });
        }
      }
    }
    customElements.define('lab-consent', LabConsent);
  }
  } catch(e) { console.error(e); }
})();

})();
